export enum DepartmentId {
    Vob = 5,
    Authorization = 6,
    Operation = 12
}